export default "__VITE_ASSET__Cne6Wo3H__"